<template>
    <!-- Learning Library expansion panels for Content Selection -->
    <v-expansion-panels v-if="getFilteredContentHeaders.length > 0">
        <v-expansion-panel focusable v-for="(content, index) in getFilteredContentHeaders" :key="index">
            <template v-slot:title> {{ content }} </template>
            <v-expansion-panel-text>
                <div v-if="filteredContents[content] && filteredContents[content].length > 0">
                    <v-virtual-scroll :height="scrollHeight" :items="['1']">
                        <v-row class="pa-8" justify="center">
                            <v-col cols="12" md="6" class="mx-auto" no-gutters
                                v-for="contentItem in filteredContents[content]" :key="contentItem.contentid">
                                <div v-if="contentItem.contentBlock !== 'Items'">
                                    <ItemCard :item="contentItem" @add-selection="addSelection"
                                        @remove-selection="removeSelection"
                                        :in-cart="`${contentItem.contentId}` in getSelections" />
                                </div>
                            </v-col>
                        </v-row>
                    </v-virtual-scroll>
                </div>
                <div v-else>
                    <v-card>
                        <v-card-title>
                            No content to add.
                        </v-card-title>
                    </v-card>
                </div>

            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
    <v-card v-if="getFilteredContentHeaders.length === 0">
        <v-card-title class="text-center text-wrap">No content to select.</v-card-title>
    </v-card>
</template>

<script>
import axios from 'axios';
import ItemCard from './ItemCard.vue';

export default {
    name: "ContentPanel",
    components: {
        ItemCard
    },
    data() {
        return {
            selected: false,
            currentContents: {},
            filteredContents: {}
        }
    },
    emits: ['addSelection', 'removeSelection'],
    computed: {
        getContentHeaders() {
            this.fetchData();
            return this.contents;
        },
        getFilteredContentHeaders(){
            if (this.filter){
                if (this.filter['selectedCategories'].length > 0) {
                    return this.getContentHeaders.filter(header => this.filter['selectedCategories'].includes(header));
                }
            }
            return this.getContentHeaders;
            
        },
        scrollHeight() {
            return `${window.innerHeight / 2}px`
        },
        getSelections() {  // Update everytime selection changes
            return this.selections;
        },
    },
    methods: {
        dummyFunction() {
            alert("clicked")
        },
        async fetchData() {
            try {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                for (let i = 0; i < this.contents.length; i++) {
                    let data = [];
                    for (let x = 0; x < this.contentGroup.length; x++) {
                        const response = await axios.get(`/api/unifiedcontent/category/${this.contentGroup[x]}/${this.contents[i]}`);
                        let responseData = response.data;
                        responseData.forEach(content => data.push(content));
                    }
                    this.currentContents[this.contents[i]] = Array.isArray(data) ? data : [];

                    // Sort the objects by content block.
                    this.currentContents[this.contents[i]] = 
                    this.alphabetical_sort_object_of_objects(this.currentContents[this.contents[i]], "contentBlock");
                }
                this.setFilteredContent();
                return;
            } catch (error) {
                console.log(error);
            }

            return [];
        },
        inCart(itemKey) {
            console.log(`${itemKey}`)
            let val = (this.selections) ?
                `${itemKey}` in this.selections : false;
            return val
        },
        // Methods to propogate information to parent
        addSelection(selection) {
            this.$emit('addSelection', selection)
        },
        removeSelection(selection) {
            this.$emit('removeSelection', selection)
        },

        setFilteredContent() {
            var filteredContents = {}
            console.log("I am here");
            for (let i = 0; i < this.contents.length; i++) {

                let filtered = this.currentContents[this.contents[i]];
                console.log(filtered);
                console.log(`First 1 ${filtered}`)
                if (this.filter != undefined) {

                    if (this.filter['selectedPages']) {
                        console.log("Inside selected pages");
                        let term = this.filter['selectedPages'];
                        filtered = filtered.
                            filter(content =>
                                content.pageTitle == term || content.subPageTitle == term);
                    }

                    // console.log(`Past Selected Pages ${filtered}`)

                    if (this.filter['searchQuery']) {
                        console.log("Inside search");
                        console.log("Searching");
                        let term = this.filter['searchQuery'].toLowerCase();
                        if (term !== "") {
                            filtered = filtered.filter(content =>
                                content.item.toLowerCase().includes(term) ||
                                content.itemDescription.toLowerCase().includes(term) ||
                                content.pageTitle.toLowerCase().includes(term) ||
                                content.subPageTitle.toLowerCase().includes(term));
                        }
                    }

                    // console.log(`Past Search ${filtered}`)
                }
                filteredContents[this.contents[i]] = filtered;
            }
            this.filteredContents = filteredContents;
        },
        alphabetical_sort_object_of_objects(data, attr) {
            var arr = [];

            // Extract identification and sort keys
            for (let prop in data) {
                if (Object.hasOwn(data, prop)) {
                    let obj = {};
                    obj[prop] = data[prop];
                    obj.tempSortName = data[prop][attr].toLowerCase();
                    arr.push(obj);
                }
            }

            // Arrange each object by the sort key
            arr.sort((a, b) => {
                var at = a.tempSortName,
                    bt = b.tempSortName;
                return at > bt ? 1 : (at < bt ? -1 : 0);
            });

            // Arrange each actual object by the sorted order
            var result = [];
            for (var i = 0, l = arr.length; i < l; i++) {
                let obj = arr[i];
                delete obj.tempSortName;
                for (let prop in obj) {
                    if (Object.hasOwn(obj, prop)) {
                        var id = prop;
                    }
                }
                var item = obj[id];
                result.push(item);
            }
            return result;
        }
    },
    mounted() {
        this.fetchData();
    },
    props: {
        contents: {
            type: Array,
            required: true,
        },
        contentGroup: {
            type: Array,
            required: true,
        },
        selections: Object,
        filter: {
            type: Object
        }
    },
    watch: {
        filter() {
            console.log("change");
            if (this.filter){
                this.setFilteredContent();
            }
        },
        contentGroup(){
            this.fetchData();
        }
    }
}
</script>